import { render, staticRenderFns } from "./NCustomFormInput.vue?vue&type=template&id=bbdaa70e&scoped=true"
import script from "./NCustomFormInput.vue?vue&type=script&lang=js"
export * from "./NCustomFormInput.vue?vue&type=script&lang=js"
import style0 from "./NCustomFormInput.vue?vue&type=style&index=0&id=bbdaa70e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdaa70e",
  null
  
)

export default component.exports